var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diy-topbar__logo"},[_c('transition',{attrs:{"name":"scale-in"}},[(_vm.showLogo)?_c('div',{staticClass:"diy-topbar__logo-wrapper"},[_c('img',{staticClass:"diy-topbar__logo-image",attrs:{"src":_vm.DIYLogo,"alt":"diy-logo"}})]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }